import { render, staticRenderFns } from "./SecurityManagerPrivilegeSetting.vue?vue&type=template&id=44f0e807&scoped=true&"
import script from "./SecurityManagerPrivilegeSetting.vue?vue&type=script&lang=js&"
export * from "./SecurityManagerPrivilegeSetting.vue?vue&type=script&lang=js&"
import style0 from "./SecurityManagerPrivilegeSetting.vue?vue&type=style&index=0&id=44f0e807&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0e807",
  null
  
)

export default component.exports